import React from "react";
import { useHistory } from "react-router-dom";
import { SETTINGS } from "config/routing";
import Breadcrumbs from "./components/header/Breadcrumbs";
import UserIcon from "../../components/icons/components/UserIcon";
import DollarIcon from "../../components/icons/components/DollarIcon";
import CouponIcon from "../../components/icons/components/CouponIcon";

const settingsOptions = [
  {
    title: "User management",
    description: "Invite your team, create users and roles",
    buttonLabel: "Manage users",
    Icon: UserIcon,
    path: SETTINGS.SETTINGS_DYNAMIC_COUPONS_QR,
  },
  {
    title: "Billing",
    description: "Access your invoices and add payment method",
    buttonLabel: "Access billing",
    Icon: DollarIcon,
    path: SETTINGS.SETTINGS_DYNAMIC_COUPONS_QR,
  },
  {
    title: "Dynamic coupons & QR",
    description: "Create your variables",
    buttonLabel: "Create variables",
    Icon: CouponIcon,
    path: SETTINGS.SETTINGS_DYNAMIC_COUPONS_QR,
  },
];

const SettingsPage = () => {
  const { push } = useHistory();
  return (
    <div className="p-10">
      {/* Breadcrumbs */}
      <Breadcrumbs />

      {/* Title */}
      <h1 className="text-[#011533] text-[32px] font-extrabold mb-6">Settings</h1>

      {/* List */}
      <ul className="bg-[#f9fafb] grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 justify-items-center">
        {settingsOptions.map((option, index) => (
          <li
            key={index}
            className="bg-white shadow-md rounded-lg p-4 pb-6 flex flex-col items-center text-center w-[320px]"
          >
            <div className="flex gap-6">
              <div className="">
                {/* Title */}
                <h3 className="text-[18px] font-bold text-[#2E3860] text-start mb-2">{option.title}</h3>
                {/* Description */}
                <p className="text-[14px] text-[#0C172C] text-start mb-4">{option.description}</p>
                {/* Button */}
                <button
                  onClick={() => push(option.path)}
                  className="w-[180px] border-1 border-solid border-[#273754] text-[#00112B] py-2 px-6 rounded-[12px] font-bold transition duration-200 hover:bg-[#011533] hover:text-white"
                >
                  {option.buttonLabel}
                </button>
              </div>
              {/* Icon */}
              <div className="flex items-center">
                <option.Icon stroke="#011533" /> {/* Pass the stroke prop */}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SettingsPage;
